import {Tabs, TabsColorScheme, TabsContainer} from "@/shared/TabsContainer";
import {DevicesOutlined} from "@mui/icons-material";
import {DevicesFragment} from "./devices/DevicesFragment";
import React from "react";
import {PathComponent} from "@/index";
import {AppTabsContainer} from "@/shared/AppTabsContainer";
import {BaseModuleMain, BaseModuleMainProps, BaseModuleMainState,} from "@/elements-shared/BaseModuleMain";
import {BaseApp} from "@/shared/BaseApp";
import {StyledBoxRow} from "@/shared/StyledComponents";
import {PD_MD} from "@/shared/dimens";

enum Tab {
  DEVICES = "devices",
}

const TABS: Tabs<Tab> = {
  items: [
    {
      type: Tab.DEVICES,
      path: "devices",
      text: "Devices",
      iconType: DevicesOutlined,
      render: path => <DevicesFragment path={path}/>,
    },
  ],
  titleElement: <StyledBoxRow style={{alignItems: "center"}}>
    <img src={"/images/dentwyze_vantage_logotype.svg"} style={{height: 48, margin: PD_MD}}/>
  </StyledBoxRow>,
  containerId: "main",
}

export type ModuleMainProps = BaseModuleMainProps & {}

type ModuleMainState = BaseModuleMainState & {}

export class ModuleMain extends BaseModuleMain<ModuleMainProps, ModuleMainState> {

  static nestedPaths(prefixPath?: string): PathComponent[] {
    return TabsContainer.nestedPathsFromTabs(TABS, prefixPath);
  }

  protected renderContainerContent(): React.ReactElement | null {
    const tabsColorScheme: TabsColorScheme = BaseApp.CONTEXT.getPreferredColorScheme() || "light";
    return <AppTabsContainer
      path={this.props.path}
      modulePath={this.props.modulePath}
      noLogo={true}
      noUserButton={true}
      tabs={TABS}
      tabsThemeColor={this.theme.palette.grey[tabsColorScheme as string === "light" ? 100 : 900]}
      tabsColorScheme={tabsColorScheme}
    />;
  }
}